module.exports = __webpack_public_path__ + "img/03.57c84401.jpg";